import { ChangeDetectionStrategy, Component, computed, input } from '@angular/core';
import { FlexLayoutModule } from '@ngbracket/ngx-layout';
import { TranslateModule } from '@ngx-translate/core';
import { NgxSkeletonLoaderModule } from 'ngx-skeleton-loader';

const line = (width: string, height: string) => ({ width, height, margin: '0' });

@Component({
  selector: 'cipo-assignments-skeleton',
  templateUrl: './assignments-skeleton.component.html',
  imports: [FlexLayoutModule, NgxSkeletonLoaderModule, TranslateModule],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class AssignmentsSkeletonComponent {
  readonly showRate = input(false);
  readonly showAllocation = input(false);

  readonly detailsPercent = computed(() => 70 - (this.showRate() ? 10 : 0) - (this.showAllocation() ? 10 : 0));

  readonly theme = {
    field: { width: '120px', height: '48px', 'border-radius': '4px', margin: '0' },
    select: { height: '48px', 'border-radius': '4px', margin: '0' },
    icon: { width: '24px', height: '24px', margin: '0' },
  };

  readonly rows = [
    { name: line('46%', '16px'), org: line('30%', '13px'), roles: line('38%', '13px') },
    { name: line('38%', '16px'), org: line('26%', '13px'), roles: line('44%', '13px') },
    { name: line('52%', '16px'), org: line('34%', '13px'), roles: line('30%', '13px') },
    { name: line('42%', '16px'), org: line('28%', '13px'), roles: line('36%', '13px') },
  ];
}
